import { render, staticRenderFns } from "./WidgetAppointments.vue?vue&type=template&id=1982aebc&scoped=true"
import script from "./WidgetAppointments.vue?vue&type=script&lang=js"
export * from "./WidgetAppointments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1982aebc",
  null
  
)

export default component.exports